import { PathConfigMap } from "@react-navigation/native";
import { kRoute } from "./kRoute";

type tConfig = {
  initialRouteName?: string | undefined;
  screens: PathConfigMap;
};

export const kConfig: tConfig = {
  initialRouteName: kRoute.P02,
  screens: {
    [kRoute.P00]: "*",
    // login
    [kRoute.P01]: `/login`,
    [kRoute.P01_01]: "/application",
    [kRoute.P01_02]: `/application_sent`,
    [kRoute.P01_03]: `/forgot`,
    [kRoute.P01_04]: `/reset`,
    [kRoute.P01_05]: `/create-user`,
    [kRoute.P105]: { path: "/r", parse: { uuid: (uuid) => decodeURI(uuid) } },
    "/": {
      screens: {
        // management
        [kRoute.P02]: `/dashboard`,
        [kRoute.P03]: `/orders`,
        [kRoute.P03_01]: `/orders_view`,
        [kRoute.P03_02]: `/orders_drafts`,
        [kRoute.P03_03]: `/abandoned-carts`,
        [kRoute.P03_04]: `/payouts`,
        [kRoute.P04]: `/messages`,
        [kRoute.P04_01]: `/messages_conversation`,
        [kRoute.P05]: `/promotions`,
        [kRoute.P06]: `/connections`,
        [kRoute.P06_05]: `/connections_admin`,
        [kRoute.P06_09]: `/connections_admin_brand`,
        [kRoute.P06_10]: `/connections_admin_retailer`,
        [kRoute.P06_11]: `/connections_admin_rep`,
        [kRoute.P08]: `products`,
        [kRoute.P08_01]: `products_edit`,
        [kRoute.P09]: `/profile`,
        [kRoute.P09_01]: `/profile-preview`,
        [kRoute.P11]: `/status`,
        [kRoute.P10]: `/retailer`,
        [kRoute.P12]: `/reps`,
        [kRoute.P13]: `/applications`,
        [kRoute.P14]: `/customers`,
        [kRoute.P15]: `/saved-brands`,
        [kRoute.P16]: `/transactions`,
        [kRoute.P16_01]: `/transaction-details`,
        [kRoute.P17]: `/rep-my-brands`,
        [kRoute.P18]: `/rep-my-retailers`,
        [kRoute.P19]: `/referrals-and-rewards`,
        [kRoute.P20]: `/sales-rep`,
        [kRoute.P21]: `/retailer-my-brands`,
        // storefront
        [kRoute.P99]: `shop`,
        [kRoute.P100]: { path: `shop_brand`, parse: { brand: (brand) => decodeURI(brand) } },
        [kRoute.P101]: { path: `shop_brand_products`, parse: { brand: (brand) => decodeURI(brand) } },
        [kRoute.P102]: `shop_checkout`,
        [kRoute.P103]: `shop_create_draft`,
      },
    },
    [kRoute.P104]: `shopify-auth`,
  },
};
